import { combineReducers } from 'redux';
import * as ActionTypes from '../actions/types';

const paginate = ({ types }) => {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected types to be an array of three elements.');
  }
  if (!types.every((type) => typeof type === 'string')) {
    throw new Error('Expected types to be strings.');
  }

  const [requestType, successType, failureType] = types;

  const updatePagination = (state, action) => {
    switch (action.type) {
      case requestType:
        return {
          ...state,
          isFetching: true,
        };
      case successType:
        return {
          ...state,
          isFetching: false,
          ids: action.response.result,
          totalPages: action.response.totalPages,
        };
      case failureType:
        return {
          ...state,
          isFetching: false,
        };
      default:
        return state;
    }
  };

  let oldPath = '';
  return (state = {
    currentPath: '',
    isFetching: false,
    pageNumber: 0,
    pageSize: 10,
    totalPages: 0,
    ids: [],
  }, action) => {
    switch (action.type) {
      case requestType:
      case successType:
      case failureType: {
        return {
          ...state,
          ...updatePagination(state, action),
        };
      }
      case ActionTypes.UPDATE_PAGE:
        return {
          ...state,
          pageNumber: action.pageNumber,
        };
      case ActionTypes.UPDATE_PAGE_SIZE:
        return {
          ...state,
          pageNumber: 0,
          pageSize: action.pageSize,
        };
      case "@@router/LOCATION_CHANGE":
        if (action.payload.location.pathname !== oldPath) {
          oldPath = action.payload.location.pathname;
          return {
            ...state,
            currentPath: action.payload.location.pathname,
            pageNumber: 0,
          };
        }
        else return state;

      default:
        return state;
    }
  };
};

const pagination = combineReducers({
  clients: paginate({
    types: [
      ActionTypes.FETCH_CLIENTS_REQUEST,
      ActionTypes.FETCH_CLIENTS_SUCCESS,
      ActionTypes.FETCH_CLIENTS_FAILURE,
    ],
  }),
  users: paginate({
    types: [
      ActionTypes.FETCH_USERS_REQUEST,
      ActionTypes.FETCH_USERS_SUCCESS,
      ActionTypes.FETCH_USERS_FAILURE,
    ],
  }),
  payments: paginate({
    types: [
      ActionTypes.FETCH_PAYMENTS_REQUEST,
      ActionTypes.FETCH_PAYMENTS_SUCCESS,
      ActionTypes.FETCH_PAYMENTS_FAILURE,
    ],
  }),
  terminals: paginate({
    types: [
      ActionTypes.FETCH_TERMINALS_REQUEST,
      ActionTypes.FETCH_TERMINALS_SUCCESS,
      ActionTypes.FETCH_TERMINALS_FAILURE,
    ],
  }),
  cards: paginate({
    types: [
      ActionTypes.FETCH_CARDS_REQUEST,
      ActionTypes.FETCH_CARDS_SUCCESS,
      ActionTypes.FETCH_CARDS_FAILURE,
    ],
  }),
  achs: paginate({
    types: [
      ActionTypes.FETCH_ACHS_REQUEST,
      ActionTypes.FETCH_ACHS_SUCCESS,
      ActionTypes.FETCH_ACHS_FAILURE,
    ],
  }),
});

export default pagination;
